import React, { useState } from "react";
import BlogContext from "./BlogContext";

const BlogState=(props)=>{
    const[blogs,setBlogs]=useState([]);
    const[hotBlog,setHotBlog]=useState({});
    const[myBlog,setMyBlog]=useState(null);
    const getAllBlog=async()=>{
        const response=await fetch(`${process.env.REACT_APP_API_URL}blog`);
        const data=await response.json();
        setBlogs((prev)=>{
            return data.articles
        });
        // console.log(blogs)
    }

    const hotBlogCall=async(hotslug)=>{
        const response=await fetch(`${process.env.REACT_APP_API_URL}blog/slug/${hotslug}`);
        const data=await response.json();
        setHotBlog(()=>{
            return data.articles
        });
    }

    const getMyBlog=async()=>{
        const response=await fetch(`${process.env.REACT_APP_API_URL}blog/myblogs`,{
            method:"GET",
            headers:{
                "auth-token":localStorage.getItem("auth-token")
            }
        });
        const data=await response.json();
        if(!data.success){
            return setMyBlog({totalArticle:0})
        }
        setMyBlog(data);
        
    }
    return(
        <BlogContext.Provider value={{blogs,getAllBlog,hotBlog,hotBlogCall,getMyBlog,myBlog}}>
            {props.children}
        </BlogContext.Provider>
    )
}

export default BlogState;